import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
// import { Elements, StripeProvider } from 'react-stripe-elements';
import './About.css';


class About extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order']
        }
    }

    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
    }

    render() {
        return (
            <div>
                <section className="apps-gotlocked-order-section" id="apps-gotlocked-order">
                    <div className="apps-gotlocked-order-container">
                        <div className="container">
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>About</h1>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <br /><br />
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-contact-form-content wow fadeIn" data-wow-delay="100ms">
                                        <div>
                                            <h2>About Us</h2>
                                        </div>
                                        <div>
                                            We are industry professionals with over 15 years of experience in the locksmith business. Our goal is to make the search for a good and reputable locksmith as easy as possible in the Google and Yelp era.
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="apps-gotlocked-contact-form-content wow fadeIn" data-wow-delay="100ms">
                                        <div>
                                            <h2>Have more questions? <span>Get in touch!</span></h2>
                                            <div className="apps-gotlocked-contact-form">
                                                <form action="#" method="POST" id="apps-gotlocked-form">
                                                    <input type="email" id="apps-gotlocked-input-email" name="email" placeholder="12345@domain.com" />
                                                    <textarea name="massage" id="apps-gotlocked-input-message" cols="30" rows="10" placeholder="Your Message Here.."></textarea>

                                                    <div className="apps-gotlocked-submit-btn-ar">
                                                        <input type="submit" name="Send Message" value="Send Message" id="apps-gotlocked-input-send" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


export default About;